import callApi from './callApi';

export const getFilterPresets = async (projectId, type) => {
  const url = `filter-presets?filterType=${type}`;
  const headers = {
    'X-Project-Id': projectId,
  };
  return callApi(url, headers);
};

export const createFilterPreset = async (projectId, data) => {
  const url = `filter-presets`;
  const headers = {
    'X-Project-Id': projectId,
  };
  return callApi(url, headers, 'POST', data);
};

export const updateFilterPreset = async (projectId, presetId, data) => {
  const url = `filter-presets/${presetId}`;
  const headers = {
    'X-Project-Id': projectId,
  };
  return callApi(url, headers, 'PATCH', data);
};

export const deleteFilterPreset = async (projectId, presetId) => {
  const url = `filter-presets/${presetId}`;
  const headers = {
    'X-Project-Id': projectId,
  };
  return callApi(url, headers, 'DELETE');
};
